

export function removeDupes(array:string[]):string[] {
  return array.filter((item, index) => array.indexOf(item) === index);
}